// Shared merchant KYC helpers — status is ALWAYS derived from backend data, never assumed.
export const normalizeKyc = (raw) => {
  const s = (raw || 'not_started').toLowerCase();
  return (s === 'pending' ? 'under_review' : s).toUpperCase();
};

export const kycRoute = (raw) => {
  const s = normalizeKyc(raw);
  if (s === 'APPROVED') return '/dashboard';
  if (s === 'SUBMITTED' || s === 'UNDER_REVIEW') return '/kyc/status';
  return '/kyc';
};

export const KYC_META = {
  NOT_STARTED: { label: 'Not Started', dot: 'bg-slate-400', text: 'text-slate-500', badge: 'bg-slate-500/10 text-slate-600 border-slate-500/30' },
  DRAFT: { label: 'In Progress', dot: 'bg-blue-500', text: 'text-blue-600', badge: 'bg-blue-500/10 text-blue-600 border-blue-500/30' },
  SUBMITTED: { label: 'Under Review', dot: 'bg-amber-500', text: 'text-amber-600', badge: 'bg-amber-500/10 text-amber-600 border-amber-500/30' },
  UNDER_REVIEW: { label: 'Under Review', dot: 'bg-amber-500', text: 'text-amber-600', badge: 'bg-amber-500/10 text-amber-600 border-amber-500/30' },
  APPROVED: { label: 'Approved', dot: 'bg-green-500', text: 'text-green-600', badge: 'bg-green-500/10 text-green-600 border-green-500/30' },
  REJECTED: { label: 'Rejected', dot: 'bg-red-500', text: 'text-red-600', badge: 'bg-red-500/10 text-red-600 border-red-500/30' },
  REUPLOAD_REQUIRED: { label: 'Action Required', dot: 'bg-orange-500', text: 'text-orange-600', badge: 'bg-orange-500/10 text-orange-600 border-orange-500/30' },
};

export const kycMeta = (raw) => KYC_META[normalizeKyc(raw)] || KYC_META.NOT_STARTED;

// 3 onboarding steps (Business Details / KYC Documents / Verification) from backend `steps`
export const kycStepsDone = (steps) => {
  if (!steps) return 0;
  let n = 0;
  if (steps.business_details === 'done') n += 1;
  if (['submitted', 'approved'].includes(steps.kyc_documents)) n += 1;
  if (steps.verification === 'approved') n += 1;
  return n;
};

export const DOC_STATUS_META = {
  uploaded: { label: 'Uploaded', cls: 'text-blue-600' },
  under_review: { label: 'Under Review', cls: 'text-amber-600' },
  verified: { label: 'Verified', cls: 'text-green-600' },
  rejected: { label: 'Rejected', cls: 'text-red-600' },
  reupload_required: { label: 'Re-upload Required', cls: 'text-orange-600' },
};

export const ENTITY_TYPES = [
  { value: 'individual', label: 'Individual' },
  { value: 'proprietorship', label: 'Proprietorship' },
  { value: 'partnership', label: 'Partnership' },
  { value: 'llp', label: 'LLP' },
  { value: 'private_limited', label: 'Private Limited' },
  { value: 'trust', label: 'Trust' },
  { value: 'society', label: 'Society / Other' },
];

export const formatDate = (iso) => {
  if (!iso) return '—';
  try {
    return new Date(iso).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
  } catch { return iso; }
};
